import React, { Suspense } from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Paper,
  CircularProgress
} from '@mui/material';
import TeamGroupManagementPanel from './TeamGroupManagementPanel';
import AdminNavigation from '../AdminNavigation';

// Loading component for Suspense
const LoadingPanel = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
    <CircularProgress size={60} />
  </Box>
);

const TeamGroups = () => {
  return (
    <Container maxWidth="xl">
      <Paper elevation={0} sx={{ mb: 3, p: 3, bgcolor: 'background.default' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          User & Team Management
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage users, teams, team groups.
        </Typography>
      </Paper>

      <AdminNavigation currentPath="/admin/team-groups-management" />

      <Box sx={{ py: 3 }}>
        <Suspense fallback={<LoadingPanel />}>
          <TeamGroupManagementPanel key="team-group-panel" />
        </Suspense>
      </Box>
    </Container>
  );
};

export default TeamGroups; 